// TableLoader.js
import React from "react";
import "./TableLoader.css";

const TableLoader = () => {
  return (
    <div className="table-loader-overlay">
      <div className="table-loader-spinner"></div>
      <p className="table-loader-text">Loading table...</p>
    </div>
  );
};

export default TableLoader;
